import Vue from 'vue'
import Vuex from 'vuex'

import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    batteryDialogDismissed: false,
  },
  mutations: {
    toggleBatteryDialogDismissedMutation(state) {
      state.batteryDialogDismissed = !state.batteryDialogDismissed
    }
  },
  actions: {
    toggleBatteryDialogDismissedAction({commit}) {
      commit('toggleBatteryDialogDismissedMutation')
    }
  },
  modules: {
    user
  }
})
